const initValues = { spokenRoutes: [] };

const spokenRoutes = {
  ...initValues,
};

export default spokenRoutes;
